<div class="loader-container" *ngIf="!view && !viewErrorMessage">
  <app-loading-dots size="5px"></app-loading-dots>
</div>
<div
  *ngIf="view"
  class="scaffold-view-panel"
  [ngClass]="{
    'show-properties': movingItem.propertiesItem,
    'is-saving': isSaving,
  }">
  <div
    class="processing-state"
    *ngIf="trackUpdates && updateStatusService.processingStatus && false"
    [ngClass]="{
      processing: updateStatusService.processingStatus == 'PROCESSING',
      'processing-completed':
        updateStatusService.processingStatus == 'COMPLETED',
      'processing-error': updateStatusService.processingError,
    }">
    <span *ngIf="updateStatusService.processingStatus == 'PROCESSING'"
      >{{ 'processing' | translation }} &nbsp;&nbsp;</span
    >
    <p-progress-spinner ariaLabel="loading" *ngIf="loading" />
    <span *ngIf="updateStatusService.processingStatus == 'COMPLETED'">
      {{ updateStatusService.processingMessage }}
    </span>
  </div>
  <div class="breadcrumb-holder" *ngIf="showEdit">
    <span>
      <a routerLink="/data-models/{{ view?.type }}">{{
        view?.type | friendlyType
      }}</a>
      <span class="breadcrumb-seperator">
        <i class="fas fa-chevron-right" style="font-size: 10px"></i>
      </span>
      <span>{{ view?.title || view?.mode }}</span>
    </span>
  </div>
  <p *ngIf="checkKeys(view_data) && showEdit" style="color: red">
    {{ 'preview_changes_not_save_lingo' | translation }}.
  </p>
  <div
    class="child-note"
    *ngIf="view.clone_from?.id && !view.clone_from.seperate_clone">
    This item is updated from
    <a
      href="/{{ view.clone_from.type }}/{{ view.clone_from.id }}"
      target="_blank"
      >{{ view.clone_from.title }}</a
    >, last updated {{ view.clone_from.updated_at | localizeDate: 'medium' }}
  </div>
  <div
    class="child-note"
    *ngIf="view.clone_from?.id && view.clone_from?.seperate_clone">
    This item has deviated from original master
    <a
      href="/{{ view.clone_from.type }}/{{ view.clone_from.id }}"
      target="_blank"
      >{{ view.clone_from.title }}</a
    >, seperated on
    {{ view.clone_from.seperate_clone | localizeDate: 'medium' }}
  </div>
  <div
    class="scaffold-page-buttons"
    *ngIf="isRoot && !iframeService?.isInIframe">
    <!--button pButton status="primary" *ngIf="checkKeys(view_data)" (click)='logEdits()'>Log Edits</button>-->
    <p-splitbutton
      [model]="savemenu"
      [label]="'save' | translation"
      icon="fas fa-save"
      (onClick)="save()"
      severity="info"
      variant="outlined"
      class="pull-right"
      *ngIf="
        !showEdit &&
        (!isSaveDisabled() || isSaving) &&
        !(
          type === 'courses' && instanceDetails?.scaffoldType === 'ai-detection'
        ) &&
        !hasConfigureComponent()
      " />
    <!--  <nb-button-group *ngIf="!showEdit && (!isSaveDisabled() || isSaving )" status="scaffold" class="pull-right">
      <button pButton severity="scaffold" [nbSpinner]="isSaving" nbSpinnerStatus="basic" [pTooltip]="'Save ' + itemsService.getGlobalData()" (click)='save()'><i class="fas fa-save"></i> <span>{{'save'|translation}}</span></button>
      <button pButton severity="scaffold" title="Save Menu" [nbContextMenu]="savemenu" [nbContextMenuTag]="identifier"><i class="fas fa-chevron-down"></i></button>

    </nb-button-group>-->
    <button
      *ngIf="
        !showEdit &&
        type == 'courses' &&
        !isSyncDisabled() &&
        !disableSync &&
        disableRestore &&
        instanceDetails?.scaffoldType &&
        instanceDetails?.scaffoldType !== 'ai-detection'
      "
      class="pull-right"
      severity="info"
      variant="outlined"
      pButton
      [pTooltip]="
        'push_courses_or_any_changes_from_scaffold_to_lms' | translation
      "
      [loading]="syncing"
      [disable]="syncing"
      (click)="push()">
      <span *ngIf="!syncing"
        ><i class="fas fa-sync"></i>
        {{
          'sync_to_lms'
            | translation
            | translationFromString
            | transformText: 'capitalize'
        }}</span
      ><span *ngIf="syncing"
        ><span>{{ syncing }}</span></span
      >
    </button>
    <button
      *ngIf="
        !showEdit &&
        this.type == 'courses' &&
        !isSyncDisabled() &&
        disableSync &&
        !disableRestore &&
        instanceDetails?.scaffoldType &&
        instanceDetails?.scaffoldType !== 'ai-detection' &&
        instanceDetails?.scaffoldType !== 'archive' &&
        !instanceDetails?.no_self_serve
      "
      class="pull-right"
      severity="info"
      variant="outlined"
      pButton
      [pTooltip]="'attempt_to_restore_course_deleted_in_lms' | translation"
      [loading]="syncing"
      [disable]="syncing"
      (click)="restore()">
      <span *ngIf="!syncing"
        ><i class="fas fa-sync"></i>
        {{
          'restore'
            | translation
            | translationFromString
            | transformText: 'capitalize'
        }}</span
      ><span *ngIf="syncing"
        ><span>{{ syncing }}</span></span
      >
    </button>
    <p-splitbutton
      [title]="'push_courses_or_any_changes_from_scaffold_to_lms' | translation"
      [disabled]="syncing"
      severity="info"
      variant="outlined"
      [model]="syncmenu"
      [label]="
        'sync_to_lms'
          | translation
          | translationFromString
          | transformText: 'capitalize'
      "
      [icon]="syncing ? 'fas fa-sync fa-spin' : 'fas fa-sync'"
      (onClick)="push()"
      class="pull-right"
      *ngIf="
        !showEdit &&
        this.type == 'courses' &&
        !isSyncDisabled() &&
        !disableSync &&
        !disableRestore &&
        instanceDetails?.scaffoldType === 'archivev2' &&
        instanceDetails?.system_type &&
        ['brightspace', 'canvas'].includes(instanceDetails?.system_type) &&
        !instanceDetails?.no_self_serve
      " />
    <button
      class="pull-right"
      severity="info"
      variant="outlined"
      pButton
      [pTooltip]="
        'push_courses_or_any_changes_from_scaffold_to_lms' | translation
      "
      [loading]="syncing"
      [disable]="syncing"
      (click)="push()"
      *ngIf="
        !showEdit &&
        this.type == 'courses' &&
        !isSyncDisabled() &&
        !disableSync &&
        !disableRestore &&
        instanceDetails?.scaffoldType &&
        instanceDetails?.scaffoldType !== 'ai-detection' &&
        (instanceDetails?.scaffoldType !== 'archivev2' ||
          !['brightspace', 'canvas'].includes(instanceDetails?.system_type) ||
          instanceDetails?.no_self_serve)
      ">
      <span *ngIf="!syncing"
        ><i class="fas fa-sync"></i>
        {{
          'sync_to_lms'
            | translation
            | translationFromString
            | transformText: 'capitalize'
        }}</span
      ><span *ngIf="syncing"
        ><span>{{ syncing }}</span></span
      >
    </button>
    <!--<nb-button-group status="scaffold" class="pull-right" *ngIf="!showEdit && this.type =='courses' && !isSyncDisabled() && !disableSync && !disableRestore && (instanceDetails?.scaffoldType && instanceDetails?.scaffoldType!=='ai-detection')">
       <button
            class="pull-right"
              severity="info"
              pButton
              [pTooltip]="'push_courses_or_any_changes_from_scaffold_to_lms'|translation"              
              [nbSpinner]="syncing" nbSpinnerStatus="primary"
              [disable]="syncing" (click)='push()'
              >
        <span *ngIf="!syncing"><i class="fas fa-sync"></i> {{'sync_to_lms'|translation|translationFromString | transformText :'capitalize'}}</span><span *ngIf="syncing"><span>{{syncing}}</span></span>
      </button>
      <button 
              severity="info"
              pButton
              *ngIf="instanceDetails?.scaffoldType==='archivev2'"
              [nbContextMenu]="syncmenu"
              [nbContextMenuTag]="identifier"
              ><i [pTooltip]="'attempt_to_restore_course_deleted_in_lms'|translation" class="fas fa-chevron-down"></i></button>
    </nb-button-group>-->
    <p-splitbutton
      [title]="
        'push_update_of_changes_from_parent_course_to_children' | translation
      "
      [disabled]="syncing"
      severity="info"
      variant="outlined"
      [model]="menu"
      [label]="
        'update_children'
          | translation
          | translationFromString
          | transformText: 'capitalize'
      "
      [icon]="syncingChild ? 'fas fa-sync fa-spin' : 'fas fa-sync'"
      (onClick)="push()"
      class="pull-right"
      *ngIf="
        !showEdit &&
        this.type == 'courses' &&
        view.child_courses &&
        view.child_courses.length > 0 &&
        !syncingChild &&
        !isSyncDisabled()
      " />
    <!--<button class="pull-right"
            pButton
            severity="scaffold"
            title="{{'push_update_of_changes_from_parent_course_to_children'|translation}}"
            *ngIf="!showEdit && this.type =='courses' && view.child_courses && view.child_courses.length > 0 && !syncingChild && !isSyncDisabled()"
            [disable]="syncing"
            [nbSpinner]="syncingChild" nbSpinnerStatus="basic"
            [nbContextMenu]="menu"
            [nbContextMenuTag]="identifier">
      <span *ngIf="!syncingChild"><i class="fas fa-sync"></i>{{'update_children'|translation|translationFromString | transformText :'capitalize'}}</span><span *ngIf="syncingChild"><span>{{syncingChild}}</span></span>update_children
    </button>-->
    <!--NEBULAR TODO-->
    <button
      class="pull-right"
      pButton
      [title]="'toggle_version_panel' | translation"
      severity="info"
      variant="outlined"
      *ngIf="
        !showEdit &&
        this.type == 'courses' &&
        instanceDetails?.scaffoldType === 'designer'
      "
      (click)="toggleVersion()">
      {{ 'versions' | translation }}
    </button>

    <!--<button pButton status="info" *ngIf=" !showEdit" (click)='log()'>LOG</button>-->
    <button
      class="pull-right"
      pButton
      status="info"
      variant="outlined"
      routerLink="edit"
      *ngIf="showEdit">
      {{ 'edit' | translation }}
    </button>
    <button
      class="pull-right"
      pButton
      status="info"
      variant="outlined"
      (click)="updateOverrideView()"
      *ngIf="overriddenView">
      {{ 'pull_latest' | translation }}
    </button>
  </div>
  <div
    class="align-center fa-2x"
    *ngIf="view && view.loading && !viewErrorMessage">
    <scaffold-loading-animation></scaffold-loading-animation>
  </div>
  <div class="app-view" *ngIf="!htmlContent">
    <app-view
      *ngIf="view && view?.data"
      [items]="view?.data?.content"
      [info]="view"
      [data]="view_data"></app-view>
  </div>
  <div class="html-view" *ngIf="htmlContent">
    <div [innerHTML]="htmlContent | safeHtml"></div>
  </div>
  <div class="saving-screen-cover">
    <div class="saving-screen-cover-content">
      <p>{{ 'saving' | translation }}...</p>
      <scaffold-loading-animation></scaffold-loading-animation>
    </div>
    <div class="saving-screen-cover-background"></div>
  </div>
</div>

<app-error-view *ngIf="viewErrorMessage">
  <div class="message-box">
    <p class="error-head">404</p>
    <p class="error-message">{{ viewErrorMessage }}</p>

    <div class="buttons-con">
      <div class="action-link-wrap">
        <app-button
          style="margin: 12px; display: inline-block"
          (click)="back()"
          >{{ 'back' | translation }}</app-button
        >
        <app-button style="cursor: pointer" (click)="home()">{{
          'home' | translation
        }}</app-button>
      </div>
    </div>
  </div>
</app-error-view>
